<template>
  <section>
    <v-data-table
      class="px-1 elevation-2 my-4"
      :headers="tableHeaders"
      :items="materials"
      :items-per-page="100"
      hide-default-footer
      item-key="material_id"
      no-data-text="Sin materiales"
    >
      <template v-slot:item.code="{ item }">
        <span style="font-size: 12.5px">{{ item.code }}</span>
      </template>
      <template v-slot:item.description="{ item }">
        <span style="font-size: 12.5px" class="d-flex justify-content-start">{{
          item.description
        }}</span>
      </template>
      <template v-slot:item.quantity="{ item }">
        <span style="font-size: 12.5px">{{ item.quantity }}</span>
      </template>
      <template v-slot:item.price="{ item }">
        <span
          v-if="
            !item.documents ||
              item.documents.find(
                (document) =>
                  document.coin && document.coin === 'CLP' && document.selected
              )
          "
        >
          {{ "$ " + item.price.toLocaleString("es", optionsFormatting) }}
        </span>
        <span v-else>
          {{
            `${item.documents
              .find((document) => document.selected)
              .price.toLocaleString("es", optionsFormatting)} ${
              item.documents.find((document) => document.selected).coin
            }`
          }}
        </span>
      </template>
      <template v-slot:item.price_in_clp="{ item }">
        <span
          v-if="
            item.documents &&
              item.documents.find(
                (document) => document.coin && document.coin !== 'CLP'
              )
          "
        >
          {{ "$ " + item.price.toLocaleString("es", optionsFormatting) }}
        </span>
        <span v-else>
          -
        </span>
      </template>
      <template v-slot:item.unique_supplier="{ item }">
        <span style="font-size: 12.5px">{{
          getServiceIsUniqueSupplier(item) ? "✅" : "❌"
        }}</span>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { formatCurrency } from "@/helpers/common";

export default {
  props: {
    materials: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getServiceIsUniqueSupplier(service) {
      return (
        (service &&
          service.documents &&
          service.documents.find((document) => {
            return document.unique_supplier;
          })) ||
        false
      );
    },
    formatCurrency,
  },
  data() {
    return {
      optionsFormatting: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      tableHeaders: [
        {
          text: "Código",
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: "Descripción",
          align: "start",
          sortable: false,
          value: "description",
        },
        {
          text: "Cantidad solicitada",
          align: "start",
          sortable: false,
          value: "quantity",
        },
        {
          text: "Precio",
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: "Precio en Pesos",
          align: "start",
          sortable: false,
          value: "price_in_clp",
        },
        {
          text: "Proveedor Único",
          align: "start",
          sortable: false,
          value: "unique_supplier",
        },
      ],
    };
  },
};
</script>

<style></style>